import React from "react";
import { ProTile, ProBar, ProText } from "./proficiency_element";
import ReactTooltip from "react-tooltip";
const ProficiencyTile = ({ data }) => {
  return (
    <ProTile>
      <ProText>{data.title}</ProText>

      <div data-tip={data.experience + " out of 10"}>
        <ProBar>
          <div
            style={{
              position: "relative",
              borderRadius: "50px",
              width: `${data.percent}%`,
              height: "15px",
              backgroundColor: "var(--primary)",
            }}
          ></div>
        </ProBar>
      </div>

      <ReactTooltip place="top" type="light" effect="float" />
    </ProTile>
  );
};

export default ProficiencyTile;
